import { Injectable } from '@angular/core';
import { KeyValuePair } from './model/key-value-pair';

@Injectable()
export class FlaggedEnum {
  constructor() {
    //console.log('con');
  }

  public toStringArray(value: number, enumType: any): string[] {
    const list = [];
    for (const prop in enumType) {
      // eslint-disable-next-line no-bitwise
      if (parseInt(enumType[prop], 10) & value) {
        list.push(prop);
      }
    }
    return list;
  }

  public toNumberArray(value: number, enumType: any): number[] {
    const list: number[] = [];
    for (const prop in enumType) {
      const enumValue = parseInt(enumType[prop], 10);
      // eslint-disable-next-line no-bitwise
      if (enumValue & value) {
        list.push(enumValue);
      }
    }
    return list;
  }

  public toArrayType<T>(value: T, typeEnum: any): Record<string, number> {
    const list: any = {};
    for (const prop in typeEnum) {
      const enumItem = typeEnum[prop];
      // eslint-disable-next-line no-bitwise
      if (+enumItem & +value) {
        list[enumItem] = prop;
      }
    }
    return list;
  }

  public hasFlag(source: number, value: number): boolean {
    // eslint-disable-next-line no-bitwise
    return (source & value) == value;
  }

  public toKeyValuePair<T>(value: T, typeEnum: any): KeyValuePair<string> {
    const keyValuePair = new KeyValuePair<string>();
    for (const prop in typeEnum) {
      const enumItem = typeEnum[prop];
      // eslint-disable-next-line no-bitwise
      if (+enumItem & +value) {
        keyValuePair.add(prop, enumItem);
      }
    }
    return keyValuePair;
  }

  public toKeyValue(typeEnum: any): KeyValuePair<string> {
    const keys = Object.keys(typeEnum);
    const keyValuePair = new KeyValuePair<string>();
    for (const key in keys) {
      keyValuePair.add(typeEnum[key], key);
    }
    return keyValuePair;
  }

  public getValue(typeEnum: any, key: string) {
    const value: any = typeEnum[key];
    return value;
  }
}
